import React from 'react';

interface IProps extends React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
    /** Start date as a Unix date */
    start?: number
}

const now: Date = new Date();
now.setHours(0);
now.setMinutes(0);
now.setSeconds(0);
now.setMilliseconds(0);
const day: number = 1000 * 60 * 60 * 24;
const TimeAgoSelect: React.FC<IProps> = (props: IProps) => {
    const { start } = props;
    let today: number = start ? start : now.valueOf();
    return (
        <select className="form-control" {...props}>
            <option value={undefined}>Custom</option>
            <option value={today - (day)}>1 Day</option>
            <option value={today - (3 * day)}>3 Days</option>
            <option value={today - (7 * day)}>1 Week</option>
            <option value={today - (14 * day)}>2 Weeks</option>
            <option value={today - (31 * day)}>1 Month</option>
            <option value={today - (60 * day)}>2 Months</option>
            <option value={today - (30 * 6 * day)}>6 Months</option>
            <option value={today - (365 * day)}>1 Year</option>
        </select>
    );
}

export default TimeAgoSelect;